import { useSelector } from "react-redux";
import { transformPermissions } from "../hooks/use-permission";

// Routes.js
import React, { Suspense, lazy } from "react";
import {
  Route,
  Outlet,
  Navigate,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

const RootLayout = lazy(() => import("../pages/Root"));

// HOME PAGE
const DashboardPage = lazy(() => import("../pages/dashboard/Dashboard"));
const SubscribePage = lazy(() => import("../pages/subscription/SubscribePage"));

// PRODUCT MANAGEMENT
const ProductManagement = lazy(() =>
  import("../pages/productManagement/stock-products/list/StockProducts")
);

const EditProduct = lazy(() =>
  import("../pages/productManagement/stock-products/view/EditProduct")
);

const AddProduct = lazy(() =>
  import("../pages/productManagement/stock-products/list/AddProduct")
);

const OfferPage = lazy(() => import("../pages/productManagement/offers/index"));
const GenericOfferPage = lazy(() =>
  import("../pages/productManagement/offers/genericOffer/index")
);
const ProductSpecificOfferPage = lazy(() =>
  import("../pages/productManagement/offers/productSpecificOffer/index")
);

const ListOfServices = lazy(() =>
  import("../pages/productManagement/LIstOfServices/List/index")
);

const ViewListedServices = lazy(() =>
  import("../pages/productManagement/stock-products/view/EditProduct")
);

const AddServises = lazy(() =>
  import("../pages/productManagement/stock-products/list/AddProduct")
);

// AUTH
const AuthLayout = lazy(() => import("../pages/auth"));
const LoginPage = lazy(() => import("../pages/auth/login"));

// SALES
const SalesOrder = lazy(() => import("../pages/sales/salesOrder/List"));
const Quotation = lazy(() => import("../pages/sales/quotations/List"));
const SalesInvoice = lazy(() =>
  import("../pages/sales/salesInvoice/List/index")
);
const CreateSalesOrder = lazy(() =>
  import("../pages/sales/salesOrder/createOrder")
);
const EditSalesOrder = lazy(() =>
  import("../pages/sales/salesOrder/createOrder")
);
const ViewSalesOrder = lazy(() =>
  import("../pages/sales/salesOrder/view/view-edit/ViewSalesOrder")
);

const CreateQuotation = lazy(() =>
  import("../pages/sales/quotations/createQuotation")
);
const EditQuotation = lazy(() =>
  import("../pages/sales/quotations/createQuotation")
);
const ViewQuotation = lazy(() =>
  import("../pages/sales/quotations/view/view-edit/ViewQuotation")
);

const ViewInvoice = lazy(() =>
  import("../pages/sales/salesInvoice/view/index")
);

const MakePayment = lazy(() =>
  import("../pages/sales/salesInvoice/view/makePayment")
);

const AddCustomer = lazy(() =>
  import("../pages/sales/customers/addCustomer/AddCustomer")
);
const CustomerList = lazy(() =>
  import("../pages/sales/customers/List/CustomerList")
);

const CreateInvoice = lazy(() =>
  import("../pages/sales/salesInvoice/createInvoice/index")
);

// Sales Target
const SalesTargetList = lazy(() =>
  import("../pages/sales/salesTarget/List/salesTargetHomePage")
);

const CreateSalesTarget = lazy(() =>
  import("../pages/sales/salesTarget/createSalesTarget/CreateSalesTarget")
);

const ViewSalesTarget = lazy(() =>
  import(
    "../pages/sales/salesTarget/viewOrEditSalesTarget/ViewOrEditSalesTarget"
  )
);

//SERVICES

// Service Request

const ServiceList = lazy(() => import("../pages/service/ServiceList/index"));
const ServiceRequest = lazy(() =>
  import("../pages/service/serviceRequest/List/index")
);

const ServiceRequestView = lazy(() =>
  import("../pages/service/serviceRequest/View/index")
);

const CreateserviceRequest = lazy(() =>
  import("../pages/service/serviceRequest/CreateServiceRequest/index")
);

//JOB CARD -----------------------------------------------------------------------
const CreateJobCardFromSerivceReq = lazy(() =>
  import("../pages/service/jobCard/CreateJobCard/index")
);

const JobCard = lazy(() => import("../pages/service/jobCard/List/index"));

const ViewJobCard = lazy(() =>
  import("../pages/service/jobCard/view/view-edit/ViewSalesOrder")
);

const EditJobCard = lazy(() =>
  import("../pages/service/jobCard/CreateJobCard")
);
// const EditSalesOrder = lazy(() =>
//   import("../pages/sales/salesOrder/createOrder")
// );

const ServiceRequestInvoice = lazy(() =>
  import("../pages/service/serviceRequestInvoice/index")
);

const Tools = lazy(() => import("../pages/service/toolsList/index"));

// PURCHASE----------------------------------------------------------------------------
const PurchaseOrder = lazy(() =>
  import("../pages/purchase/purchaseOrder/List/index")
);
const CreatePurchaseOrder = lazy(() =>
  import("../pages/purchase/purchaseOrder/createOrder")
);
const EditPurchaseOrder = lazy(() =>
  import("../pages/purchase/purchaseOrder/createOrder")
);
const ViewPurchaseOrder = lazy(() =>
  import("../pages/purchase/purchaseOrder/view/view-edit/ViewPurchaseOrder")
);

//PURCHASE ORDER BY CUSTOMER ----------------------------------------------------------
const PurchaseOrderFromCustomer = lazy(() =>
  import("../pages/purchase/poFromCustomer/List/index")
);
const CreatePurchaseOrderFromCustomer = lazy(() =>
  import("../pages/purchase/poFromCustomer/createOrder")
);
const EditPurchaseOrderFromCustomer = lazy(() =>
  import("../pages/purchase/poFromCustomer/createOrder")
);
const ViewPurchaseOrderFromCustomer = lazy(() =>
  import("../pages/purchase/poFromCustomer/view/view-edit/ViewPurchaseOrder")
);

const AddVendor = lazy(() =>
  import("../pages/purchase/vendors/addVendor/AddVendor")
);
const VendorList = lazy(() =>
  import("../pages/purchase/vendors/List/VendorList")
);

const PurchaseBill = lazy(() =>
  import("../pages/purchase/purchaseBill/List/index")
);

const ViewBill = lazy(() =>
  import("../pages/purchase/purchaseBill/view/index")
);

const MakeNillPayment = lazy(() =>
  import("../pages/purchase/purchaseBill/view/makePayment/index")
);

// REPORTS ------------------------------------------------------------------
const InventoryReports = lazy(() =>
  import("../pages/reports/inventory/catalogList/InventoryList")
);
const InventoryListing = lazy(() =>
  import("../pages/reports/inventory/productList/StockProducts")
);
const SalesReport = lazy(() =>
  import("../pages/reports/salesReport/SalesReport")
);
const ProfitLossReports = lazy(() =>
  import("../pages/reports/profitLoss/SalesAndProfitReport")
);

const TaxReport = lazy(() => import("../pages/reports/taxReport/List/TaxList"));

const Payments = lazy(() => import("../pages/receivables/payments/List/index"));
const ReceivablesInvoice = lazy(() =>
  import("../pages/receivables/receivablesInvoice/List/index")
);

const SalesTargetReport = lazy(() =>
  import("../pages/reports/salesTargetReport/SalesTargetReportList")
);

const SalesTargetReportGraph = lazy(() =>
  import("../pages/reports/salesTargetReport/SalesTargetGraph")
);

const LadgerReport = lazy(() =>
  import("../pages/reports/ladgerReport/LadgerReport")
);
const SalesBookReport = lazy(() =>
  import("../pages/reports/salesBookReport/SalesBookReport")
);

const PurchaseBookReport = lazy(() =>
  import("../pages/reports/purchaseBookReport/purchaseBookReport")
);

// SETTINGS ----------------------------------------------------------------------
const TenantInfo = lazy(() => import("../pages/admin/tenantInfo/index"));

const CreateUserPage = lazy(() => import("../pages/admin/users/createUser"));
const Users = lazy(() => import("../pages/admin/users/List/UserList"));
const ViewUser = lazy(() => import("../pages/admin/users/View/ViewUser"));
const MyPackage = lazy(() => import("../pages/admin/LoggedInUserPackage/Page"));
const AddExpenses = lazy(() => import("../pages/admin/AddExpenses/index"));
const BusinessSettings = lazy(() =>
  import("../pages/admin/BusinessSettings/index")
);
const ThemeSettings = lazy(() =>
  import("../pages/admin/ThemeSelector/ThemeSelector")
);
const EmployeeList = lazy(() => import("../pages/admin/employes/index"));
const AddEmployee = lazy(() => import('../pages/admin/employes/AddEmployee/AddEmployee'));
const EmployeeExpensesList = lazy(() => import('../pages/admin/employes/EmployeeExpenses/List'));

//SUPER-ADMIN---------------------------------------------------------------------
const PackageCreation = lazy(() =>
  import("../pages/superAdmin/package/packageCreation/PackageCreation")
);
const PackageListing = lazy(() =>
  import("../pages/superAdmin/package/packageListing/index")
);
const SubscriptionListing = lazy(() =>
  import("../pages/superAdmin/subscriptions/subscriptionListing/index")
);
const TenantListing = lazy(() =>
  import("../pages/superAdmin/tenant/tenantListing/index")
);

const CreateTenantPage = lazy(() => import("../pages/auth/createTenant"));

const InitialPasswordChange = lazy(() =>
  import("../components/ChangeInitialPassword/Page")
);

//SERVICE REQUEST PAGE
const ServiceRequestPage = lazy(() =>
  import("../pages/auth/ServiceRequest/serviceRequestPage")
);

const ServiceRequestiframes = lazy(() =>
  import("../pages/auth/ServiceRequest/index")
);

//USER WALLET LIST
const UserWalletCustomerList = lazy(() =>
  import("../pages/sales/User wallet/UserWalleCustomertList")
);
//   const UserWallet = lazy(() => import('../pages/sales/User wallet/UserWallet'));

export default function ProtectedRoutes() {
  const { details } = useSelector((state) => state.user);
  const transformRoutesVariable = transformPermissions(
    details?.roleAndPermissions?.permissions
  );
  return (
    <Route>
      <Route path="/" element={<RootLayout />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="subscribe" element={<SubscribePage />} />

        <Route path="product-management" element={<Outlet />}>
          {transformRoutesVariable.product_management.stock_product.READ && (
            <Route path="Stocked-Products" element={<Outlet />}>
              <Route index element={<ProductManagement />} />
              {transformRoutesVariable.product_management.stock_product
                .READ && <Route path="view" element={<EditProduct />} />}
              {transformRoutesVariable.product_management.stock_product
                .UPDATE && <Route path="edit" element={<EditProduct />} />}
              {transformRoutesVariable.product_management.stock_product
                .CREATE && (
                <Route path="add-product" element={<AddProduct />} />
              )}
            </Route>
          )}

          {transformRoutesVariable.product_management.service_listing.READ && (
            <Route path="service-listing" element={<Outlet />}>
              <Route index element={<ListOfServices />} />
              {transformRoutesVariable.product_management.service_listing
                .READ && <Route path="view" element={<ViewListedServices />} />}
              {transformRoutesVariable.product_management.service_listing
                .UPDATE && (
                <Route path="edit" element={<ViewListedServices />} />
              )}
              {transformRoutesVariable.product_management.service_listing
                .CREATE && (
                <Route path="add-Service" element={<AddServises />} />
              )}
            </Route>
          )}
          {transformRoutesVariable.product_management.offers.READ && (
            <Route path="offer" element={<Outlet />}>
              <Route index element={<OfferPage />} />
              {transformRoutesVariable.product_management.offers.READ && (
                <Route path="view" element={<EditProduct />} />
              )}
              {transformRoutesVariable.product_management.offers.UPDATE && (
                <Route path="edit" element={<EditProduct />} />
              )}
              {transformRoutesVariable.product_management.offers.CREATE && (
                <Route path="generic-offer" element={<GenericOfferPage />} />
              )}
              {transformRoutesVariable.product_management.offers.UPDATE && (
                <Route
                  path="product-specific-offer"
                  element={<ProductSpecificOfferPage />}
                />
              )}
            </Route>
          )}
        </Route>

        <Route path="purchase" element={<Outlet />}>
          {transformRoutesVariable.purchases.po_form_customer.READ && (
            <Route path="from-customer" element={<Outlet />}>
              <Route index element={<PurchaseOrderFromCustomer />} />
              {transformRoutesVariable.purchases.po_form_customer.CREATE && (
                <Route
                  path="create"
                  element={<CreatePurchaseOrderFromCustomer />}
                />
              )}
              {transformRoutesVariable.purchases.po_form_customer.READ && (
                <Route
                  path="view"
                  element={<ViewPurchaseOrderFromCustomer />}
                />
              )}
              {transformRoutesVariable.purchases.po_form_customer.UPDATE && (
                <Route
                  path="edit"
                  element={<EditPurchaseOrderFromCustomer />}
                />
              )}
            </Route>
          )}
          {transformRoutesVariable.purchases.purchase_order.READ && (
            <Route path="order" element={<Outlet />}>
              <Route index element={<PurchaseOrder />} />
              {transformRoutesVariable.purchases.purchase_order.CREATE && (
                <Route path="create" element={<CreatePurchaseOrder />} />
              )}
              {transformRoutesVariable.purchases.purchase_order.READ && (
                <Route path="view" element={<ViewPurchaseOrder />} />
              )}
              {transformRoutesVariable.purchases.purchase_order.UPDATE && (
                <Route path="edit" element={<EditPurchaseOrder />} />
              )}
            </Route>
          )}
          {transformRoutesVariable.purchases.vendors.READ && (
            <Route path="vendors" element={<Outlet />}>
              <Route index element={<VendorList title="Vendor" />} />
              {transformRoutesVariable.purchases.vendors.CREATE && (
                <Route path="add" element={<AddVendor />} />
              )}
            </Route>
          )}
          {transformRoutesVariable.purchases.bills.READ && (
            <Route path="bills" element={<Outlet />}>
              <Route index element={<PurchaseBill />} />
              {transformRoutesVariable.purchases.bills.READ && (
                <Route path="view" element={<Outlet />}>
                  <Route index element={<ViewBill />} />
                  <Route path="make-payments" element={<MakeNillPayment />} />
                </Route>
              )}
            </Route>
          )}
        </Route>

        <Route path="sales" element={<Outlet />}>
          {transformRoutesVariable.sales.sales_order.READ && (
            <Route path="order" element={<Outlet />}>
              <Route index element={<SalesOrder />} />
              {transformRoutesVariable.sales.sales_order.CREATE && (
                <Route path="create" element={<CreateSalesOrder />} />
              )}
              {transformRoutesVariable.sales.sales_order.READ && (
                <Route path="view" element={<ViewSalesOrder />} />
              )}
              {transformRoutesVariable.sales.sales_order.UPDATE && (
                <Route path="edit" element={<EditSalesOrder />} />
              )}
            </Route>
          )}
          {transformRoutesVariable.sales.customers.READ && (
            <Route path="customers" element={<Outlet />}>
              <Route index element={<CustomerList title="Customer" />} />
              {transformRoutesVariable.sales.customers.CREATE && (
                <Route path="add" element={<AddCustomer />} />
              )}
            </Route>
          )}
          {transformRoutesVariable.sales.invoices.READ && (
            <Route path="invoices" element={<Outlet />}>
              <Route index element={<SalesInvoice />} />
              {transformRoutesVariable.sales.invoices.CREATE && (
                <Route path="create-invoice" element={<CreateInvoice />} />
              )}
              {transformRoutesVariable.sales.invoices.READ && (
                <Route path="view" element={<Outlet />}>
                  <Route index element={<ViewInvoice />} />
                  <Route path="make-payments" element={<MakePayment />} />
                </Route>
              )}
            </Route>
          )}
          {transformRoutesVariable.sales.sales_order.READ && (
            <Route path="quotations" element={<Outlet />}>
              <Route index element={<Quotation />} />
              {transformRoutesVariable.sales.sales_order.CREATE && (
                <Route path="create" element={<CreateQuotation />} />
              )}
              {transformRoutesVariable.sales.sales_order.READ && (
                <Route path="view" element={<ViewQuotation />} />
              )}
              {transformRoutesVariable.sales.sales_order.UPDATE && (
                <Route path="edit" element={<EditQuotation />} />
              )}
            </Route>
          )}
          {transformRoutesVariable.sales.credit_wallet.READ && (
            <Route path="wallet" element={<Outlet />}>
              {transformRoutesVariable.sales.credit_wallet.READ && (
                <Route index element={<UserWalletCustomerList />} />
              )}
            </Route>
          )}
          {transformRoutesVariable.reports.target_reports.READ && (
            <Route path="sales-target" element={<Outlet />}>
              <Route index element={<SalesTargetList />} />
              {transformRoutesVariable.reports.target_reports.CREATE && (
                <Route path="create" element={<CreateSalesTarget />} />
              )}
              {transformRoutesVariable.reports.target_reports.READ && (
                <Route path="view" element={<ViewSalesTarget />} />
              )}
            </Route>
          )}
        </Route>

        <Route path="services" element={<Outlet />}>
          {transformRoutesVariable.services.services.READ && (
            <Route path="service-list" element={<Outlet />}>
              <Route index element={<ServiceList />} />
            </Route>
          )}
          {transformRoutesVariable.services.service_request.READ && (
            <Route path="service-request" element={<Outlet />}>
              <Route index element={<ServiceRequest />} />
              {transformRoutesVariable.services.service_request.CREATE && (
                <Route path="create" element={<CreateserviceRequest />} />
              )}
              {transformRoutesVariable.services.service_request.READ && (
                <Route path="view" element={<ServiceRequestView />} />
              )}

              {/* <Route path="edit" element={<EditSalesOrder />} /> */}
            </Route>
          )}
          {transformRoutesVariable.services.job_card.READ && (
            <Route path="job-card" element={<Outlet />}>
              <Route index element={<JobCard />} />
              {transformRoutesVariable.services.job_card.CREATE && (
                <Route
                  path="create"
                  element={<CreateJobCardFromSerivceReq />}
                />
              )}
              {transformRoutesVariable.services.job_card.READ && (
                <Route path="view" element={<ViewJobCard />} />
              )}
              {transformRoutesVariable.services.job_card.UPDATE && (
                <Route path="edit" element={<EditJobCard />} />
              )}
            </Route>
          )}
          <Route path="invoices" element={<Outlet />}>
            <Route index element={<ServiceRequestInvoice />} />
          </Route>
          {transformRoutesVariable.services.tools.READ && (
            <Route path="tools-list" element={<Outlet />}>
              <Route index element={<Tools />} />
            </Route>
          )}
          {transformRoutesVariable.services.tools.READ && (
            <Route path="tools-list" element={<Outlet />}>
              <Route index element={<Tools />} />
            </Route>
          )}
        </Route>

        {transformRoutesVariable.receivables.payments.READ && (
          <Route path="receivables" element={<Outlet />}>
            <Route path="invoices" element={<Outlet />}>
              <Route index element={<ReceivablesInvoice />} />
            </Route>
            {transformRoutesVariable.receivables.payments.CREATE && (
              <Route path="payments" element={<Payments />} />
            )}
          </Route>
        )}

        <Route path="reports" element={<Outlet />}>
          {transformRoutesVariable.reports.inventory_reports.READ && (
            <Route path="inventory-report" element={<Outlet />}>
              <Route index element={<InventoryReports />} />

              <Route path="list" element={<InventoryListing />} />
            </Route>
          )}
          {transformRoutesVariable.reports.sales_reports.READ && (
            <Route path="sales-report" element={<SalesReport />} />
          )}
          {transformRoutesVariable.reports.tax_reports.READ && (
            <Route path="tax-report" element={<TaxReport />} />
          )}
          {transformRoutesVariable.reports["p&l_reports"].READ && (
            <Route path="profit-loss-report" element={<ProfitLossReports />} />
          )}
          {transformRoutesVariable.reports.target_reports.READ && (
            <Route path="sales-target-report" element={<Outlet />}>
              <Route index element={<SalesTargetReport />} />
              {transformRoutesVariable.reports.target_reports.CREATE && (
                <Route path="graph" element={<SalesTargetReportGraph />} />
              )}
              {/* {transformRoutesVariable.reports.target_reports.READ && (
                <Route path="view" element={<ViewSalesTarget />} />
              )} */}
            </Route>
          )}
          {transformRoutesVariable.reports.ladger_reports.READ && (
            <Route path="ladger-report" element={<LadgerReport />} />
          )}
          {transformRoutesVariable.reports.sales_book.READ && (
            <Route path="sales-book-report" element={<SalesBookReport />} />
          )}
          {transformRoutesVariable.reports.purchase_book.READ && (
            <Route path="purchase-report" element={<PurchaseBookReport/>} />
          )}
        </Route>

        <Route path="admin" element={<Outlet />}>
          {transformRoutesVariable.settings.users.READ && (
            <Route path="users" element={<Outlet />}>
              <Route index element={<Users />} />
              {transformRoutesVariable.settings.users.CREATE && (
                <Route path="create" element={<CreateUserPage />} />
              )}
              {transformRoutesVariable.settings.users.READ && (
                <Route path="view" element={<ViewUser />} />
              )}
            </Route>
          )}
          {transformRoutesVariable.settings.employees.READ && (
            <Route path="employees" element={<Outlet />}>
              <Route index element={<EmployeeList />} />
              {transformRoutesVariable.settings.employees.CREATE && (
                <Route path="create" element={<AddEmployee />} />
              )}
              {/* {transformRoutesVariable.settings.employees.READ && (
                <Route path="view" element={<ViewUser />} />
              )} */}
            </Route>
          )}
          {transformRoutesVariable.settings.employees_expenses.READ && (
            <Route path="employees-expenses" element={<Outlet />}>
              <Route index element={<EmployeeExpensesList />} />
            </Route>
          )}
          {transformRoutesVariable.settings.business.READ && (
            <Route path="business" element={<Outlet />}>
              {transformRoutesVariable.settings.business.READ && (
                <Route index element={<TenantInfo />} />
              )}
            </Route>
          )}
          {transformRoutesVariable.settings.business_settings.READ && (
            <Route path="business-settings" element={<Outlet />}>
              {transformRoutesVariable.settings.business_settings.READ && (
                <Route index element={<BusinessSettings />} />
              )}
            </Route>
          )}

          <Route path="my-package" element={<MyPackage />}></Route>
          <Route path="theme" element={<ThemeSettings />}></Route>
          {transformRoutesVariable.settings.expenses.READ && (
            <Route path="expenses" element={<AddExpenses />}></Route>
          )}
        </Route>

        <Route path="*" element={<Navigate to="/" />} />
      </Route>
      <Route path="/service-request-page" element={<ServiceRequestPage />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Route>
  );
}
